import React from 'react'
import styled from 'styled-components'
import Fade from 'react-reveal/Fade'
import Typical from 'react-typical'
import Capti from '../images/logo.jpeg'

const Mission = () => {

    return (
        <>
         <Wrap >
          <Box>
			<img src={Capti} />
         <Fade bottom>
				<ItemText>
					<Heading >Our Mission :</Heading>
					<h1>To help students interested in technology to meet other
like-minded students and to help advance their careers.</h1>
                     
                     <h2>CodeZen offers a multitude of fun, exciting, and beginner-friendly events designed to enrich and grow your understanding of in-demand skills, a community of like-minded students and alumni ready to tackle anything that comes their way, and plenty of opportunities for members to network and collaborate on projects and hackathons.

Whether you're looking to jumpstart your career in Software Engineering, Data Science, Cybersecurity, UX/UI Design, and many other related fields, or just want to drop by to chill and make some new friends, there's something for everyone here at CodeZen.</h2>
				</ItemText>
			</Fade>
      </Box>
         </Wrap>
        </>
    );

}

export default Mission;

const Heading = styled.div`
    font-size : 80px;
    color : green;
`

const Wrap = styled.div `
color: black;
    background-color: white;
	width: 100vw;
	min-height: 100vh;
	background-size: cover; /* set size to cover */
	background-position: center; /* center the image */
	background-repeat: no-repeat; /* dont repeat the background */

	display: flex;
	flex-direction: row; /* switch to vertical */
	justify-content: center; /* horizontal alignment */
	align-items: center; /* vertical alignment */

	@media (max-width : 768px){
		flex-direction: column;
	}

 `

const ItemText = styled.div `
	padding-top: 15vh;
	text-align: center;
`


const Box = styled.div `
color: black;

background-color: rgb(253, 253, 243) ;
width: 100vw;
height: 80vh;
background-size: cover; /* set size to cover */
background-position: center; /* center the image */
background-repeat: no-repeat; /* dont repeat the background */

display: flex;
flex-direction: row; /* switch to vertical */
justify-content: center; /* horizontal alignment */
align-items: center; /* vertical alignment */

@media (max-width : 768px){
	flex-direction: column;
}

`